"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotMyBusiness = exports.Error = exports.Wrapper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const business_address_1 = __importDefault(require("../business-address"));
exports.Wrapper = styled_components_1.default.div.withConfig({ displayName: "reports-Wrapper", componentId: "reports-nxi10f" }) `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.neutral100};
  padding: 16px 24px;
  height: 100%;
  & > :first-child {
    margin-bottom: 16px;
  }
  gap: 10px;
`;
exports.Error = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ size: 'sm' })).withConfig({ displayName: "reports-Error", componentId: "reports-1srvxz9" }) `
  padding: 24px;
`;
const NotMyBusiness = ({ className, error, link, title, businessAddress, copy, }) => {
    var _a;
    if (error) {
        return (react_1.default.createElement(exports.Error, { className: className }, "Your score didn't load correctly \u2014 our bad. Please refresh your browser to load your score."));
    }
    const businessAddressArray = Array.isArray(businessAddress) ? businessAddress : [businessAddress];
    const filteredBusinessAddresses = (_a = businessAddressArray === null || businessAddressArray === void 0 ? void 0 : businessAddressArray.filter((addr) => !!addr)) !== null && _a !== void 0 ? _a : [];
    return (react_1.default.createElement(exports.Wrapper, { className: className },
        title && (react_1.default.createElement(base_react_components_1.Copy, { size: "md", bold: true }, title)),
        filteredBusinessAddresses.map((businessAddress, index) => (react_1.default.createElement(business_address_1.default, Object.assign({ key: index }, businessAddress)))),
        link && (react_1.default.createElement(base_react_components_1.Button, { variation: "buttonLink", href: link, "data-testid": "not-my-business" }, "This is not my business")),
        copy && (react_1.default.createElement(base_react_components_1.Copy, { size: "sm", light: true }, copy))));
};
exports.NotMyBusiness = NotMyBusiness;
exports.default = (0, styled_components_1.default)(exports.NotMyBusiness).withConfig({ componentId: "reports-erl7sq" }) ``;
//# sourceMappingURL=index.js.map